
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { AtividadeFilter } from '../filter';
import { AtividadeSearchCliente, AtividadeClienteRevisao } from '../cliente';

@Injectable({
    providedIn: 'root'
})
export class AtividadeClienteHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/atividade/0/cliente`;
    }

    /** Pesquisa as atividades agrupadas por cliente */
    search(filter: AtividadeFilter, offset: number, limit: number, orderBy: number, orderByDir: string): Observable<AtividadeSearchCliente[]> {
        // Params
        let params = new HttpParams()
                        .append('offset', offset.toString())
                        .append('limit', limit.toString())
                        .append('orderBy', orderBy ? orderBy.toString() : null)
                        .append('orderByDir', orderByDir ? orderByDir : null);

        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<AtividadeSearchCliente[]>(this.pathApi, {params});
    }

    /** Obtem a atividade de revisão do cliente que ainda não está concluída */
    loadClienteRevisaoPendente(idCliente: number): Observable<AtividadeClienteRevisao> {
        return this.customHttp.get<AtividadeClienteRevisao>(`${this.pathApi}/${idCliente}/revisaopendente`);
    }
}
